<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="logo-status-resp">
      <router-link to="/" class="navbar-brand" @click.native="selecionarSheriff(-1)" href="#">
        <img :src="logo" alt>
        <span>Marshall</span>
      </router-link>
      <div v-if="sheriff" :class="getBadge(sheriff.state)">Sheriff Comm: {{sheriff.state}}</div>
    </div>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#sheriffNavbar"
      aria-controls="navbarColor01"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="sheriffNavbar">
      <ul class="navbar-nav mr-auto"></ul>
      <form class="form-inline my-2 my-lg-0">
        <select
          class="form-control mr-2"
          name="sheriff-select"
          id="sheriff-select"
          @change="selecionarSheriff($event.target.value)"
        >
          <!-- <option disabled value selected>{{$t("message.select")}}</option> -->
          <option value="-1">-- TODOS --</option>
          <option
            v-for="(sh,index) of sheriffs"
            :key="sh.id.address"
            :value="index"
          >{{sh.id.address}} - {{sh.id.label}}</option>
        </select>
        <router-link to="/marshall" class="btn btn-primary my-2 my-sm-0" tag="button" type="submit">
          <font-awesome-icon icon="cogs"></font-awesome-icon>Marshall
        </router-link>
      </form>
    </div>
  </nav>
</template>

<script>
import logo from "../../assets/garten2.svg";
import { mapState } from "vuex";
import { getBadge } from "../../sheriffUtils.js";
export default {
  name: "Navbar",
  data() {
    return {
      logo
    };
  },
  computed: {
    ...mapState(["sheriffs", "sheriff"])
  },
  methods: {
    selecionarSheriff(endereco) {
      this.$store.dispatch("selecionarSheriff", endereco);
      this.$router.push("/");
    },
    getBadge
  }
};
</script>

<style scoped>
.navbar-brand img {
  height: 2rem;
}
.navbar-brand span {
  position: relative;
  top: 5px;
}
.badge {
  font-size: 1rem;
}
@media (max-width: 480px) {
  .logo-status-resp {
    display: flex;
    flex-direction: column;
  }
}
</style>
